export const parseJSON = (
  value: string | undefined | null,
  fallback: Record<string, never> | []
): ReturnType<typeof JSON.parse> | Record<string, never> => {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};
